(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('excessMessageMultipet', ['excessMessageMultipetService', function(excessMessageMultipetService) {
            return {
                scope: {
                    products: "=",
                    pet: "="
                },
                restrict: 'E',
                templateUrl: 'directives/excess-message-multipet/templates/excess-message-multipet.html',
                link: function ($scope) {
                    $scope.excessMessageMultipet = excessMessageMultipetService.getExcessMessageMultipet($scope.products, $scope.pet);
                }
            };
        }]);
})(window, window.angular);